export default __webpack_public_path__ + "static/media/frankmint.32a92de8.gif";